import { render, staticRenderFns } from "./SimpleListGroup.vue?vue&type=template&id=084bcc34&scoped=true&"
import script from "./SimpleListGroup.vue?vue&type=script&lang=js&"
export * from "./SimpleListGroup.vue?vue&type=script&lang=js&"
import style0 from "./SimpleListGroup.vue?vue&type=style&index=0&id=084bcc34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084bcc34",
  null
  
)

export default component.exports